export enum WebsitePage {
    welcome = 'websiteWelcome',
    amenities = 'websiteAmenities',
    welcomeMessage = 'websiteWelcomeMessage',
    about = 'websiteAboutUs',
    gallery = 'websiteGallery',
    buildingFeatures = 'websiteBuildingFeatures',
    neighbourhood = 'websiteNeighbourhood',
    contact = 'websiteContact',
    document = 'websiteDocument',
    announcements = 'websiteAnnouncements',
}



// WEBPACK FOOTER //
// /app/src/app/types/website-builder/website-page.ts